export const constants = {
    endpoint: "https://blogs4youapi.herokuapp.com/api"
}

//just a comment